import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import BookingHistoryPage from "./BookingHistoryPage";

const BookingHistory = () => (
  <Switch>
    <Route path="/dispatch/bookings/:id">
      <BookingHistoryPage />
    </Route>
    <Redirect to="/dispatch" />
  </Switch>
);

export default BookingHistory;
